import { space } from 'styled-system';
import styled from '@emotion/styled';

export const Wrap = styled.div`
  position: relative;
  // background-color: ${props => props.theme.colors.background};
  margin: 1.6em auto;
  max-width: 600px;
  width: 100%;
  ${space};

  a {
    outline: none;
  }

  /* used for carousel */
  .slider-control-bottomcenter {
    position: relative !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;

    ul {
      top: 0 !important;
    }
    button {
      color: ${props => props.theme.colors.brand} !important;
    }
  }
`;

export default Wrap;
